import { Breadcrumbs as MuiBreadcrumbs, Link, Typography } from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { NAVIGATION } from '@/config/navigation';
import { paths } from '@/routes/paths';

interface Crumb {
  label: string;
  to?: string;
}

/** Route-derived breadcrumbs: Dashboard › Group › Item (spec §4). */
export function AppBreadcrumbs() {
  const { pathname } = useLocation();

  const crumbs: Crumb[] = [{ label: 'Dashboard', to: paths.dashboard }];

  for (const group of NAVIGATION) {
    const match = group.items.find(
      (item) => pathname === item.path || pathname.startsWith(`${item.path}/`),
    );
    if (match) {
      if (group.label !== 'Overview') crumbs.push({ label: group.label });
      if (match.path !== paths.dashboard) crumbs.push({ label: match.label });
      break;
    }
  }

  return (
    <MuiBreadcrumbs aria-label="Breadcrumb" sx={{ mb: 2 }}>
      {crumbs.map((crumb, index) => {
        const last = index === crumbs.length - 1;
        if (crumb.to && !last) {
          return (
            <Link
              key={crumb.label}
              component={RouterLink}
              to={crumb.to}
              underline="hover"
              color="inherit"
            >
              {crumb.label}
            </Link>
          );
        }
        return (
          <Typography key={crumb.label} color={last ? 'text.primary' : 'text.secondary'}>
            {crumb.label}
          </Typography>
        );
      })}
    </MuiBreadcrumbs>
  );
}
